import { useContext } from 'react';
import { AppContext, GlobalAppContext } from '../../contexts/AppContext';

export const useGlobal = (): GlobalAppContext => {
	return useContext(AppContext);
};
